<template>
  <v-container class="px-0">
    <v-alert type="error" v-model="error">
      <div class="white--text">
        Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.
      </div>
    </v-alert>

    <v-alert type="error" v-model="errorAlreadySubscribed">
      <div class="white--text">
        Wir haben bereits eine Anmeldung über die angegebene E-Mail-Adresse erhalten.
      </div>
    </v-alert>

    <v-row>
      <v-col :class="{ 'pr-0': $vuetify.breakpoint.mdAndUp, 'py-0': $vuetify.breakpoint.smAndDown }" cols="12" md="8">
        <v-form @submit.prevent="submit" onSubmit="return false;"
          ref="form"
        >
          <!-- Mail Entry -->
          <v-text-field
            label="Ihre E-Mail-Adresse"
            :style="{ 'border-radius': $vuetify.breakpoint.smAndDown ? '10px' : '10px 0px 0px 10px' }"
            rounded
            :error-messages="notValid ? 'Bitte geben Sie eine valide E-Mail-Adresse ein.' : ''"
            :error="notValid"
            v-model="mail"
          ></v-text-field>
        </v-form>
      </v-col>
      <v-col :class="{ 'pl-0': $vuetify.breakpoint.mdAndUp, 'py-0': $vuetify.breakpoint.smAndDown }" cols="12" md="4">
        <v-btn class="primary text--text tradana-shadow" style="width: 100%; min-width: 200px; height: 56px; text-transform: none" :style="{ 'border-radius': $vuetify.breakpoint.smAndDown ? '10px' : '0 10px 10px 0' }" @click="signUp">
          Kostenfrei anmelden
        </v-btn>
      </v-col>
    </v-row>
    <p :style="{ 'font-size': $vuetify.breakpoint.smAndDown ? '10px' : '12px', color: light ? '#ECF4F0' : '' }" :class="{ 'mt-7': $vuetify.breakpoint.smAndDown, 'pa-0': $vuetify.breakpoint.smAndDown }" style="text-shadow: none">
      Ihre E-Mail-Adresse wird ausschließlich zur Kontaktaufnahme genutzt. <br v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.mdAndUp">
      Mit Klick auf anmelden akzeptieren Sie unsere <router-link :to="{ name: 'Privacy'}" :style="{ color: light ? '#ECF4F0' : 'var(--v-test-base)' }">Datenschutzerklärung</router-link>.
    </p>

    <div id="hubspotform"></div>

    <!-- Success -->
    <success-dialog :dialog="success" @close="success = false">
      Vielen Dank für Ihr Interesse.
      Wir befinden uns derzeit in einer 
      geschlossenen Testphase.<br><br>
      Wir melden uns bei Ihnen, 
      sobald wir Sie freigeschaltet haben. 
    </success-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  props: ['light', 'position'],
  data () {
    return {
      mail: '',
      success: false,
      error: false,
      errorAlreadySubscribed: false,
      notValid: false
    }
  },
  methods: {
    reset () {
      this.$refs.form.reset()
    },
    signUp () {
      this.errorAlreadySubscribed = false
      this.mail = this.mail.replace(' ', '')
      var data = {
        "fields": [
          {
            "objectTypeId": "0-1",
            "name": "email",
            "value": this.mail
          }
        ],
        "context": {
          "pageUri": "tradana.org",
          "pageName": "TRADANA"
        },
        "legalConsentOptions": {
          "consent": { // Include this object when GDPR options are enabled
            "consentToProcess": true,
            "text": "I agree to allow eternio - Gesellschaft für Erinnerungskultur mbH to store and process my personal data.",
            "communications": [
              {
                "value": true,
                "subscriptionTypeId": 999,
                "text": "I agree to receive marketing communications from eternio - Gesellschaft für Erinnerungskultur mbH."
              }
            ]
          }
        }
      }
      axios.post('https://api.hsforms.com/submissions/v3/integration/submit/25568300/bea224c8-a3db-44bd-8ae8-942401681a13', data)
      if (this.mail !== '' && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.mail)) {
        this.notValid = false
        axios.post('/tradana/subscribe', { mail: this.mail })
          .then(() => {
            this.success = true
            this.error = false
            this.errorAlreadySubscribed = false
            this.$ga.event('LandingPage', 'Subscribed_with_Mail_' + this.position, this.mail, 0)
            this.reset()
          })
          .catch(err => {
            if (err.response && err.response.status === 409) {
              this.errorAlreadySubscribed = true
            } else {
              this.error = true
            }
            this.success = false
          })
      } else {
        this.notValid = true
      }
    }
  },
  mounted () {
    // var div = document.getElementById('hubspotform')
    // var script = document.createElement('script')
    // var script2 = document.createElement('script')
    // script2.charset = 'utf-8'
    // script2.type = 'text/javascrip'
    // script2.src = '//js-eu1.hsforms.net/forms/shell.js'
    // script.innerHTML = 'hbspt.forms.create({region: "eu1",portalId: "25568300",formId: "bea224c8-a3db-44bd-8ae8-942401681a13"});'
    // div.appendChild(script2)
    // div.appendChild(script)
  }
}
</script>

<style scoped>
  * >>> .v-input__slot {
    background-color: white !important;
    box-shadow: 0px 0px 15px #3f3f3f2e;
    margin-top: -16px;
    height: 56px
  }

  * >>> .v-text-field__details {
    position: absolute;
    margin: -32px 10px;
  }

  * >>> .v-messages__message {
    color: var(--v-error-base)
  }
</style>
